import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    cargarTodosUsuarios, eliminarUsuario,
    actualizarUsuarioAdmin,
    cargarTodosMunicipios, crearMunicipio, crearUsuario,
} from '../../actions/adminAction';
import { esborrarErrorAction, esborrarOkAction } from '../../actions/ui';
import isEmail from 'validator/lib/isEmail';

const FORM_RESP = { Nombre_Resp: '', Apellidos_Resp: '', Email_Resp: '', Email_Resp2: '', Telf_Resp: '' };
const FORM_MUN  = { Nombre_Mun: '', CP_Mun: '', Habitantes_Mun: '', PagWeb_Mun: '' };
const PER_PAGE  = 10;

// ── Iconos ────────────────────────────────────────────────────────────────────
const IconSearch   = () => <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><circle cx="11" cy="11" r="8"/><path strokeLinecap="round" d="m21 21-4.35-4.35"/></svg>;
const IconPlus     = () => <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}><path strokeLinecap="round" d="M12 5v14M5 12h14"/></svg>;
const IconEdit     = () => <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/></svg>;
const IconTrash    = () => <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg>;
const IconClose    = () => <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" d="M6 18L18 6M6 6l12 12"/></svg>;
const IconWarning  = () => <svg width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"/></svg>;
const IconBack     = () => <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" d="M10 19l-7-7m0 0l7-7m-7 7h18"/></svg>;
const IconBuilding = () => <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21"/></svg>;
const IconUserPlus = () => <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z"/></svg>;
const IconChevL    = () => <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" d="M15 19l-7-7 7-7"/></svg>;
const IconChevR    = () => <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" d="M9 5l7 7-7 7"/></svg>;
const IconSwap     = () => <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" d="M7.5 21L3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5"/></svg>;

// ══════════════════════════════════════════════════════════════════════════════
// COMPONENTE PRINCIPAL
// ══════════════════════════════════════════════════════════════════════════════
export const GestioUsuaris = () => {
    const dispatch = useDispatch();
    const { auth } = useSelector(s => s);
    const { msgError, msgOk } = useSelector(s => s.ui);
    const adminUsuarios   = useSelector(s => s.adminUsuarios?.usuarios   || null);
    const adminMunicipios = useSelector(s => s.adminUsuarios?.municipios || null);

    const [modalAlta,   setModalAlta]   = useState(false);
    const [modalEditar, setModalEditar] = useState(false);
    const [modalBorrar, setModalBorrar] = useState(null);
    const [formEdit,    setFormEdit]    = useState(null);
    const [busqueda,    setBusqueda]    = useState('');
    const [pagina,      setPagina]      = useState(1);

    useEffect(() => { dispatch(cargarTodosUsuarios(auth.tokenJwt)); }, []);
    useEffect(() => {
        if (msgOk)    setTimeout(() => dispatch(esborrarOkAction()),    4000);
        if (msgError) setTimeout(() => dispatch(esborrarErrorAction()), 6000);
    }, [msgOk, msgError]);
    useEffect(() => { setPagina(1); }, [busqueda]);

    const abrirModalAlta = () => {
        if (adminMunicipios === null) {
            dispatch(cargarTodosMunicipios(auth.tokenJwt));
        }
        setModalAlta(true);
    };

    const usuariosFiltrados = (adminUsuarios || []).filter(u =>
        u.nombre_Mun?.toLowerCase().includes(busqueda.toLowerCase()) ||
        u.nombre?.toLowerCase().includes(busqueda.toLowerCase()) ||
        u.email?.toLowerCase().includes(busqueda.toLowerCase())
    );
    const totalPaginas   = Math.max(1, Math.ceil(usuariosFiltrados.length / PER_PAGE));
    const usuariosPagina = usuariosFiltrados.slice((pagina - 1) * PER_PAGE, pagina * PER_PAGE);

    const handleAbrirEditar = u => {
        setFormEdit({
            IdResponsable:  u.id,
            IdMunicipio:    u.idMunicipio || '',
            Nombre_Mun:     u.nombre_Mun  || '',
            CP_Mun:         u.cp_Mun      || '',
            Habitantes_Mun: u.Habitantes_Mun || '',
            PagWeb_Mun:     u.pagWeb_Mun  || '',
            Nombre_Resp:    u.nombre      || '',
            Apellidos_Resp: u.apellido    || '',
            Email_Resp:     u.email       || '',
            Telf_Resp:      u.telf        || '',
        });
        setModalEditar(true);
    };

    const handleEliminar = () => {
        if (modalBorrar) { dispatch(eliminarUsuario(auth.tokenJwt, modalBorrar.id)); setModalBorrar(null); }
    };

    return (
        <div>
            {/* ── Cabecera ──────────────────────────────────────────────── */}
            <div style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', gap:16, marginBottom:28, flexWrap:'wrap' }}>
                <div>
                    <p className="ca-label-super">GESTIÓN</p>
                    <h2 className="ca-h2">Gestión de Usuarios</h2>
                    <p className="ca-subtext">{adminUsuarios ? `${adminUsuarios.length} usuarios registrados` : 'Cargando...'}</p>
                </div>
                <button onClick={abrirModalAlta} className="u-btn-primary"><IconPlus /> Nuevo usuario</button>
            </div>

            {msgOk    && <div className="ms-alert-success">{msgOk}</div>}
            {msgError && <div className="ms-alert-error">{msgError}</div>}

            {/* ── Buscador ──────────────────────────────────────────────── */}
            <div className="ca-search-wrap" style={{ maxWidth:360, marginBottom:20 }}>
                <span className="ca-search-icon"><IconSearch /></span>
                <input type="text" placeholder="Buscar por municipio, nombre o email..."
                    value={busqueda} onChange={e => setBusqueda(e.target.value)}
                    className="ca-search-input" style={{ width:'100%' }} />
            </div>

            {/* ── Tabla ─────────────────────────────────────────────────── */}
            {adminUsuarios === null ? (
                <div className="u-empty-state">Cargando usuarios...</div>
            ) : usuariosFiltrados.length === 0 ? (
                <div className="u-empty-state">No se encontraron usuarios.</div>
            ) : (
                <>
                    <div style={{ border:'1px solid #e5e7eb', borderRadius:12, overflow:'hidden', background:'#fff', marginBottom:20 }}>
                        <table style={{ width:'100%', borderCollapse:'collapse', fontSize:14 }}>
                            <thead>
                                <tr style={{ background:'#f9fafb', borderBottom:'1px solid #e5e7eb' }}>
                                    {['Municipio','Responsable','Email','Teléfono',''].map((h,i) => (
                                        <th key={i} style={{ padding:'11px 16px', textAlign:i===4?'right':'left', fontSize:11, fontWeight:600, color:'#6b7280', textTransform:'uppercase', letterSpacing:'0.06em' }}>{h}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {usuariosPagina.map((u, idx) => (
                                    <tr key={u.id} style={{ borderBottom: idx < usuariosPagina.length-1 ? '1px solid #f3f4f6' : 'none', background: idx%2===0 ? '#fff' : '#fafafa' }}>
                                        <td style={{ padding:'13px 16px', fontWeight:600, color:'#111827' }}>
                                            <div>{u.nombre_Mun}</div>
                                            {u.cp_Mun && <div style={{ fontSize:12, color:'#9ca3af', fontWeight:400 }}>CP {u.cp_Mun}</div>}
                                        </td>
                                        <td style={{ padding:'13px 16px' }}>
                                            <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                                                <div className="gu-avatar">{(u.nombre||'?').charAt(0).toUpperCase()}</div>
                                                <div>
                                                    <div style={{ fontWeight:500, color:'#374151' }}>{u.nombre} {u.apellido}</div>
                                                    {u.admin==1 && <span className="u-badge-pink" style={{ fontSize:10, padding:'1px 6px', borderRadius:4 }}>Admin</span>}
                                                </div>
                                            </div>
                                        </td>
                                        <td style={{ padding:'13px 16px', color:'#6b7280' }}>{u.email}</td>
                                        <td style={{ padding:'13px 16px', color:'#6b7280' }}>{u.telf || <span style={{ color:'#d1d5db' }}>—</span>}</td>
                                        <td style={{ padding:'13px 16px', textAlign:'right', whiteSpace:'nowrap' }}>
                                            <button onClick={() => handleAbrirEditar(u)} className="gu-btn-edit"><IconEdit /> Editar</button>
                                            <button onClick={() => setModalBorrar({ id:u.id, nombre:`${u.nombre} ${u.apellido}`, municipio:u.nombre_Mun })} className="gu-btn-delete"><IconTrash /> Eliminar</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <Paginacion pagina={pagina} total={totalPaginas} onChange={setPagina}
                        desde={(pagina-1)*PER_PAGE+1} hasta={Math.min(pagina*PER_PAGE, usuariosFiltrados.length)} totalItems={usuariosFiltrados.length} />
                </>
            )}

            {/* ── Modales ───────────────────────────────────────────────── */}
            {modalAlta && (
                <ModalAlta
                    municipios={adminMunicipios}
                    token={auth.tokenJwt}
                    dispatch={dispatch}
                    onClose={() => setModalAlta(false)}
                />
            )}
            {modalEditar && formEdit && (
                <ModalEditar
                    formInicial={formEdit}
                    municipios={adminMunicipios || []}
                    token={auth.tokenJwt}
                    dispatch={dispatch}
                    onClose={() => setModalEditar(false)}
                />
            )}
            {modalBorrar && (
                <ModalBorrar usuario={modalBorrar} onConfirm={handleEliminar} onCancel={() => setModalBorrar(null)} />
            )}
        </div>
    );
};

// ══════════════════════════════════════════════════════════════════════════════
// MODAL ALTA
// ══════════════════════════════════════════════════════════════════════════════
const ModalAlta = ({ municipios: munsProp, token, dispatch, onClose }) => {
    const [paso,     setPaso]     = useState('elegir');
    const [subPaso,  setSubPaso]  = useState('municipio');
    const [formMun,  setFormMun]  = useState({ ...FORM_MUN });
    const [formResp, setFormResp] = useState({ ...FORM_RESP });
    const [munCreado,  setMunCreado]  = useState(null);
    const [muns,       setMuns]       = useState(munsProp || []);
    const [munSel,     setMunSel]     = useState(null);
    const [busq,       setBusq]       = useState('');
    const [error,      setError]      = useState('');
    const [creando,    setCreando]    = useState(false);
    const [enviando,   setEnviando]   = useState(false);
const munCreadoRedux = useSelector(s => s.adminUsuarios?.munCreado || null);

    useEffect(() => {
        if (munsProp !== null) {
            setMuns(munsProp);
        }
    }, [munsProp]);

    const munsFiltrados = muns.filter(m =>
        m.Nombre_Mun?.toLowerCase().includes(busq.toLowerCase()) || m.CP_Mun?.includes(busq)
    );

    const handleCrearMunicipio = async () => {
    if (!formMun.Nombre_Mun.trim()) { 
        setError('El nombre del municipio es obligatorio.'); 
        return; 
    }
    setError(''); 
    setCreando(true);

    const fd = new FormData();
    Object.entries(formMun).forEach(([k, v]) => { if (v) fd.append(k, v); });

    try {
        const municipioCreado = await dispatch(crearMunicipio(token, fd));
        // municipioCreado es data.contingut que resolvió la promise
        const nuevo = { 
            IdMunicipio: municipioCreado.IdMunicipio || municipioCreado, 
            Nombre_Mun:  formMun.Nombre_Mun, 
            CP_Mun:      formMun.CP_Mun 
        };
        setMunCreado(nuevo);
        setMunSel(nuevo);
        setMuns(prev => [nuevo, ...prev]);
        setBusq('');
        setCreando(false);
        setSubPaso('responsable'); // ← avanza al siguiente paso
    } catch (err) {
        setError(err.message || 'Error al crear el municipio. Inténtalo de nuevo.');
        setCreando(false);
    }
};
    // useEffect(() => {
    //     if (creando && munCreadoRedux?.IdMunicipio) {
    //         const nuevo = { IdMunicipio: munCreadoRedux.IdMunicipio, Nombre_Mun: formMun.Nombre_Mun, CP_Mun: formMun.CP_Mun };
    //         setMunCreado(nuevo);
    //         setMunSel(nuevo);
    //         setMuns(prev => [nuevo, ...prev]);
    //         setBusq('');
    //         setCreando(false);
    //         setSubPaso('responsable');
    //     }
    // }, [munCreadoRedux]);
    const validarResp = (f) => {
        if (!f.Nombre_Resp || !f.Apellidos_Resp || !f.Email_Resp) return 'Nombre, apellidos y email son obligatorios.';
        if (!isEmail(f.Email_Resp)) return 'El email no tiene un formato válido.';
        if (!f.Email_Resp2) return 'Confirma el email.';
        if (f.Email_Resp !== f.Email_Resp2) return 'Los dos emails no coinciden.';
        return '';
    };

    const handleCrearResponsable = async () => {
    const err = validarResp(formResp);
    if (err) { setError(err); return; }
    if (!munSel?.IdMunicipio) { setError('No hay municipio seleccionado.'); return; }
    
    setError(''); 
    setEnviando(true);

    const { Email_Resp2, ...datos } = formResp;

    try {
        await dispatch(crearUsuario(token, { 
            IdMunicipio: munSel.IdMunicipio, 
            ...datos 
        }));
        onClose(); // solo cierra si fue bien
    } catch (err) {
        setError(err.message || 'Error al crear el usuario. Inténtalo de nuevo.');
        setEnviando(false); // desbloquea el botón para reintentar
    }
}

    const handleBack = () => {
        if (paso === 'nuevo' && subPaso === 'responsable') { setSubPaso('municipio'); setError(''); return; }
        setPaso('elegir'); setSubPaso('municipio'); setError('');
    };

    const titulo = {
        elegir:    'Nuevo usuario',
        nuevo:     subPaso === 'municipio' ? 'Crear municipio' : 'Añadir responsable',
        existente: munSel ? `Responsable para ${munSel.Nombre_Mun}` : 'Municipio existente',
    }[paso];

    const subtitulo = {
        elegir:    '¿El municipio ya está registrado en el sistema?',
        nuevo:     subPaso === 'municipio'
                     ? 'Introduce los datos del nuevo municipio'
                     : `Municipio "${munCreado?.Nombre_Mun}" creado · ahora añade el responsable`,
        existente: 'Selecciona el municipio y rellena los datos del responsable',
    }[paso];

    return (
        <div className="u-modal-overlay" >
            <div className="u-modal-box" style={{ maxWidth:700 }}>

                <div className="u-modal-header">
                    <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                        {paso !== 'elegir' && <button onClick={handleBack} className="u-modal-close-btn"><IconBack /></button>}
                        <div>
                            <h3 className="u-modal-title">{titulo}</h3>
                            <p style={{ margin:'3px 0 0', fontSize:13, color:'#6b7280' }}>{subtitulo}</p>
                        </div>
                    </div>
                    <button onClick={onClose} className="u-modal-close-btn"><IconClose /></button>
                </div>

                {/* Stepper */}
                {paso === 'nuevo' && (
                    <div style={{ padding:'12px 28px 0', display:'flex', alignItems:'center', gap:0 }}>
                        <StepDot n={1} active={subPaso==='municipio'} done={subPaso==='responsable'} label="Municipio" />
                        <div style={{ flex:1, height:2, margin:'0 8px', background: subPaso==='responsable' ? '#111827' : '#e5e7eb', transition:'background 0.3s', marginBottom:14 }} />
                        <StepDot n={2} active={subPaso==='responsable'} done={false} label="Responsable" />
                    </div>
                )}

                <div className="u-modal-body" style={{ overflowY:'auto', maxHeight:'60vh' }}>
                    {error && <div className="ms-alert-error" style={{ marginBottom:16 }}>{error}</div>}

                    {/* Elegir */}
                    {paso === 'elegir' && (
                        <div className="u-grid-2" style={{ marginTop:8 }}>
                            <OpcionCard icono={<IconBuilding />} titulo="Municipio nuevo"     desc="Registrar un municipio que todavía no existe" color="#111827" onClick={() => { setPaso('nuevo'); setSubPaso('municipio'); }} />
                            <OpcionCard icono={<IconUserPlus />} titulo="Municipio existente" desc="Añadir un responsable a un municipio ya registrado" color="#2563eb" onClick={() => setPaso('existente')} />
                        </div>
                    )}

                    {/* Nuevo / sub municipio */}
                    {paso === 'nuevo' && subPaso === 'municipio' && (
                        <>
                            <SectionLabel icon="🏛️" label="Datos del municipio" />
                            <div className="u-grid-2">
                                <Field label="Nombre municipio *" name="Nombre_Mun"    value={formMun.Nombre_Mun}    onChange={e => setFormMun({...formMun,[e.target.name]:e.target.value})} />
                                <Field label="Código postal"      name="CP_Mun"        value={formMun.CP_Mun}        onChange={e => setFormMun({...formMun,[e.target.name]:e.target.value})} />
                                <Field label="Habitantes"         name="Habitantes_Mun" value={formMun.Habitantes_Mun} onChange={e => setFormMun({...formMun,[e.target.name]:e.target.value})} type="number" />
                                <Field label="Página web"         name="PagWeb_Mun"    value={formMun.PagWeb_Mun}    onChange={e => setFormMun({...formMun,[e.target.name]:e.target.value})} type="url" />
                            </div>
                        </>
                    )}

                    {/* Nuevo / sub responsable */}
                    {paso === 'nuevo' && subPaso === 'responsable' && (
                        <>
                            <div style={{ display:'flex', alignItems:'center', gap:10, padding:'10px 14px', background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:10, marginBottom:20 }}>
                                <span style={{ fontSize:20 }}>🏛️</span>
                                <div style={{ flex:1 }}>
                                    <div style={{ fontWeight:700, fontSize:13, color:'#15803d' }}>✓ {munCreado?.Nombre_Mun}</div>
                                    {munCreado?.CP_Mun && <div style={{ fontSize:12, color:'#16a34a' }}>CP {munCreado.CP_Mun}</div>}
                                </div>
                                <span style={{ fontSize:11, color:'#16a34a', fontWeight:600, background:'#dcfce7', padding:'2px 8px', borderRadius:20 }}>Municipio creado</span>
                            </div>
                            <SectionLabel icon="👤" label="Datos del responsable" />
                            <FormResponsable form={formResp} onChange={e => setFormResp({...formResp,[e.target.name]:e.target.value})} />
                            <InfoEmail />
                        </>
                    )}

                    {/* Existente */}
                    {paso === 'existente' && (
                        <>
                            <SectionLabel icon="🏛️" label="Seleccionar municipio" />
                            {munsProp === null ? (
                                <div className="u-empty-state" style={{ padding:12 }}>Cargando municipios...</div>
                            ) : (
                                <SelectorMunicipio
                                    municipios={munsFiltrados}
                                    busqueda={busq} onBusqueda={setBusq}
                                    seleccionado={munSel} onSelect={setMunSel}
                                    maxHeight={160}
                                />
                            )}
                            <SectionLabel icon="👤" label="Datos del responsable" />
                            <FormResponsable form={formResp} onChange={e => setFormResp({...formResp,[e.target.name]:e.target.value})} />
                            <InfoEmail />
                        </>
                    )}
                </div>

                {/* Footer */}
                {paso === 'nuevo' && subPaso === 'municipio' && (
                    <div className="u-modal-footer">
                        <button onClick={onClose} className="u-btn-secondary">Cancelar</button>
                        <button onClick={handleCrearMunicipio} disabled={creando} className="u-btn-primary" style={{ opacity:creando?0.7:1 }}>
                            {creando ? 'Creando...' : 'Crear municipio →'}
                        </button>
                    </div>
                )}
                {((paso === 'nuevo' && subPaso === 'responsable') || paso === 'existente') && (
                    <div className="u-modal-footer">
                        <button onClick={onClose} className="u-btn-secondary">Cancelar</button>
                        <button onClick={handleCrearResponsable} disabled={enviando} className="u-btn-primary" style={{ opacity:enviando?0.7:1 }}>
                            {enviando ? 'Creando...' : 'Crear usuario'}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

// ══════════════════════════════════════════════════════════════════════════════
// MODAL EDITAR
// ══════════════════════════════════════════════════════════════════════════════
const ModalEditar = ({ formInicial, municipios: munsProp, token, dispatch, onClose }) => {
    const [form,       setForm]       = useState({ ...formInicial });
    const [error,      setError]      = useState('');
    const [enviando,   setEnviando]   = useState(false);
    const [cambiarMun, setCambiarMun] = useState(false);
    const [munSel,     setMunSel]     = useState(null);
    const [busq,       setBusq]       = useState('');
    const [loadingMuns,setLoadingMuns]= useState(false);
const muns = useSelector(s => s.adminUsuarios?.municipios || []);
    const munsFiltrados = muns.filter(m =>
        m.Nombre_Mun?.toLowerCase().includes(busq.toLowerCase()) || m.CP_Mun?.includes(busq)
    );

    const abrirCambiarMun = () => {
        dispatch(cargarTodosMunicipios(token));  // ← ya no hay fetch directo
        setMunSel(null); setBusq(''); setCambiarMun(true);
    };

    const confirmarCambioMun = () => {
        if (!munSel) return;
        setForm(prev => ({
            ...prev,
            IdMunicipio:    munSel.IdMunicipio,
            Nombre_Mun:     munSel.Nombre_Mun     || '',
            CP_Mun:         munSel.CP_Mun         || '',
            Habitantes_Mun: munSel.Habitantes_Mun || '',
            PagWeb_Mun:     munSel.PagWeb_Mun     || '',
        }));
        setCambiarMun(false);
    };

    const handleGuardar = async () => {
    if (!form.Nombre_Resp || !form.Apellidos_Resp || !form.Email_Resp) { 
        setError('Nombre, apellidos y email son obligatorios.'); 
        return; 
    }
    if (!isEmail(form.Email_Resp)) { 
        setError('El email no tiene un formato válido.'); 
        return; 
    }
    setError(''); 
    setEnviando(true);

    try {
        await dispatch(actualizarUsuarioAdmin(token, form.IdResponsable, form));
        onClose(); // solo cierra si fue bien
    } catch (err) {
        setError(err.message || 'Error al actualizar el usuario. Inténtalo de nuevo.');
        setEnviando(false); // desbloquea el botón para reintentar
    }
};

    return (
        <div className="u-modal-overlay">
            <div className="u-modal-box" style={{ maxWidth:700 }}>
                <div className="u-modal-header">
                    <div>
                        <h3 className="u-modal-title">Editar usuario</h3>
                        <p style={{ margin:'3px 0 0', fontSize:13, color:'#6b7280' }}>{form.Nombre_Mun || 'Sin municipio asignado'}</p>
                    </div>
                    <button onClick={onClose} className="u-modal-close-btn"><IconClose /></button>
                </div>

                <div className="u-modal-body" style={{ overflowY:'auto', maxHeight:'65vh' }}>
                    {error && <div className="ms-alert-error" style={{ marginBottom:16 }}>{error}</div>}

                    {/* Municipio solo lectura */}
                    <div style={{ marginBottom:4 }}>
                        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', margin:'0 0 12px' }}>
                            <SectionLabel icon="🏛️" label="Municipio" noMargin />
                            <button onClick={abrirCambiarMun} className="gu-btn-swap"><IconSwap /> Cambiar municipio</button>
                        </div>
                        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8 }}>
                            {[
                                { l:'Nombre',     v: form.Nombre_Mun     },
                                { l:'CP',         v: form.CP_Mun         },
                                { l:'Habitantes', v: form.Habitantes_Mun  },
                                { l:'Web',        v: form.PagWeb_Mun     },
                            ].map(({ l, v }) => (
                                <div key={l} style={{ background:'#f9fafb', border:'1.5px solid #e5e7eb', borderRadius:8, padding:'7px 12px' }}>
                                    <div style={{ fontSize:10, fontWeight:700, color:'#9ca3af', textTransform:'uppercase', letterSpacing:'0.05em', marginBottom:2 }}>{l}</div>
                                    <div style={{ fontSize:13, color:'#374151', fontWeight:500 }}>{v || <span style={{ color:'#d1d5db' }}>—</span>}</div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Panel cambiar municipio */}
                    {cambiarMun && (
                        <div style={{ border:'1.5px solid #dbeafe', borderRadius:12, padding:16, margin:'16px 0', background:'#f8faff' }}>
                            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:10 }}>
                                <span style={{ fontSize:13, fontWeight:700, color:'#1d4ed8' }}>🔄 Cambiar municipio asignado</span>
                                <button onClick={() => setCambiarMun(false)} className="u-modal-close-btn"><IconClose /></button>
                            </div>
                            {loadingMuns ? (
                                <div className="u-empty-state" style={{ padding:12 }}>Cargando municipios...</div>
                            ) : (
                                <>
                                    <SelectorMunicipio
                                        municipios={munsFiltrados}
                                        busqueda={busq} onBusqueda={setBusq}
                                        seleccionado={munSel} onSelect={setMunSel}
                                        maxHeight={140}
                                    />
                                    <div style={{ display:'flex', gap:8, justifyContent:'flex-end', marginTop:10 }}>
                                        <button onClick={() => setCambiarMun(false)} className="u-btn-secondary">Cancelar</button>
                                        <button onClick={confirmarCambioMun} disabled={!munSel} className="u-btn-primary" style={{ opacity: munSel ? 1 : 0.45 }}>
                                            Confirmar cambio
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>
                    )}

                    {/* Responsable editable */}
                    <SectionLabel icon="👤" label="Responsable" />
                    <div className="u-grid-2">
                        <Field label="Nombre *"    name="Nombre_Resp"    value={form.Nombre_Resp}    onChange={e => setForm({...form,[e.target.name]:e.target.value})} />
                        <Field label="Apellidos *" name="Apellidos_Resp" value={form.Apellidos_Resp} onChange={e => setForm({...form,[e.target.name]:e.target.value})} />
                        <Field label="Email *"     name="Email_Resp"     value={form.Email_Resp}     onChange={e => setForm({...form,[e.target.name]:e.target.value})} type="email" />
                        <Field label="Teléfono"    name="Telf_Resp"      value={form.Telf_Resp}      onChange={e => setForm({...form,[e.target.name]:e.target.value})} type="tel" />
                    </div>
                </div>

                <div className="u-modal-footer">
                    <button onClick={onClose} className="u-btn-secondary">Cancelar</button>
                    <button onClick={handleGuardar} disabled={enviando} className="u-btn-primary" style={{ opacity:enviando?0.7:1 }}>
                        {enviando ? 'Guardando...' : 'Guardar cambios'}
                    </button>
                </div>
            </div>
        </div>
    );
};

// ── Modal Confirmar borrado ───────────────────────────────────────────────────
const ModalBorrar = ({ usuario, onConfirm, onCancel }) => (
    <div className="u-modal-overlay" >
        <div className="u-modal-box" style={{ maxWidth:700 }}>
            <div style={{ padding:'36px 32px', textAlign:'center' }}>
                <div style={{ width:64, height:64, borderRadius:'50%', background:'#fef2f2', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 20px', color:'#dc2626' }}><IconWarning /></div>
                <h3 style={{ margin:'0 0 8px', fontSize:18, fontWeight:700, color:'#111827' }}>¿Eliminar este usuario?</h3>
                <p style={{ margin:'0 0 4px', fontSize:14, color:'#6b7280' }}>Vas a eliminar a <strong style={{ color:'#111827' }}>{usuario.nombre}</strong></p>
                <p style={{ margin:'0 0 24px', fontSize:13, color:'#9ca3af' }}>Municipio: {usuario.municipio}</p>
                <div className="ms-alert-error" style={{ marginBottom:24, textAlign:'left' }}>
                    <p style={{ margin:0, fontSize:13, lineHeight:1.6 }}>⚠️ Acción <strong>irreversible</strong>. El municipio NO se eliminará.</p>
                </div>
                <div style={{ display:'flex', gap:12 }}>
                    <button onClick={onCancel}  className="u-btn-secondary" style={{ flex:1, justifyContent:'center' }}>Cancelar</button>
                    <button onClick={onConfirm} className="u-btn-danger"    style={{ flex:1, justifyContent:'center' }}>Sí, eliminar</button>
                </div>
            </div>
        </div>
    </div>
);

// ── Sub-componentes reutilizables ─────────────────────────────────────────────
const SelectorMunicipio = ({ municipios, busqueda, onBusqueda, seleccionado, onSelect, maxHeight=170 }) => (
    <>
        <div className="ca-search-wrap" style={{ marginBottom:8 }}>
            <span className="ca-search-icon"><IconSearch /></span>
            <input type="text" placeholder="Buscar municipio..." value={busqueda}
                onChange={e => onBusqueda(e.target.value)}
                className="ca-search-input" style={{ width:'100%', boxSizing:'border-box' }} />
        </div>
        <div style={{ border:'1.5px solid #e5e7eb', borderRadius:10, maxHeight, overflowY:'auto', marginBottom:4 }}>
            {municipios.length === 0
                ? <div style={{ padding:14, textAlign:'center', color:'#9ca3af', fontSize:13 }}>No se encontraron municipios</div>
                : municipios.map(m => {
                    const sel = seleccionado?.IdMunicipio === m.IdMunicipio;
                    return (
                        <div key={m.IdMunicipio} onClick={() => onSelect(m)}
                            style={{ padding:'10px 14px', cursor:'pointer', fontSize:14, borderBottom:'1px solid #f3f4f6',
                                background: sel?'#eff6ff':'#fff', color: sel?'#2563eb':'#374151', fontWeight: sel?600:400,
                                display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                            <span>{m.Nombre_Mun}</span>
                            <div style={{ display:'flex', gap:8, alignItems:'center' }}>
                                {m.CP_Mun && <span style={{ fontSize:12, color:'#9ca3af' }}>CP {m.CP_Mun}</span>}
                                {sel && <span style={{ color:'#2563eb' }}>✓</span>}
                            </div>
                        </div>
                    );
                })
            }
        </div>
    </>
);

const FormResponsable = ({ form, onChange }) => (
    <div className="u-grid-2">
        <Field label="Nombre *"          name="Nombre_Resp"    value={form.Nombre_Resp}    onChange={onChange} />
        <Field label="Apellidos *"       name="Apellidos_Resp" value={form.Apellidos_Resp} onChange={onChange} />
        <Field label="Teléfono"          name="Telf_Resp"      value={form.Telf_Resp}      onChange={onChange} type="tel" />
        <div />
        <Field label="Email *"           name="Email_Resp"     value={form.Email_Resp}     onChange={onChange} type="email" />
        <Field label="Confirmar email *" name="Email_Resp2"    value={form.Email_Resp2}    onChange={onChange} type="email"
            error={form.Email_Resp2 && form.Email_Resp !== form.Email_Resp2 ? 'No coinciden' : ''} />
    </div>
);

const InfoEmail = () => (
    <div className="ms-alert-success" style={{ marginTop:14 }}>
        📧 Se enviará un email al responsable para que establezca su contraseña.
    </div>
);

const StepDot = ({ n, active, done, label }) => (
    <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:4 }}>
        <div style={{ width:28, height:28, borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', fontSize:12, fontWeight:700,
            background: done||active ? '#111827' : '#e5e7eb',
            color: done||active ? '#fff' : '#9ca3af', transition:'all 0.3s' }}>
            {done ? '✓' : n}
        </div>
        <span style={{ fontSize:10, color: active||done ? '#111827' : '#9ca3af', fontWeight: active?700:400, whiteSpace:'nowrap' }}>{label}</span>
    </div>
);

const OpcionCard = ({ icono, titulo, desc, color, onClick }) => (
    <div onClick={onClick}
        style={{ border:'2px solid #e5e7eb', borderRadius:14, padding:'24px 20px', cursor:'pointer', textAlign:'center', background:'#fff', transition:'all 0.15s' }}
        onMouseEnter={e => { e.currentTarget.style.borderColor=color; e.currentTarget.style.background='#f9fafb'; }}
        onMouseLeave={e => { e.currentTarget.style.borderColor='#e5e7eb'; e.currentTarget.style.background='#fff'; }}>
        <div style={{ width:48, height:48, borderRadius:'50%', background: color==='#111827'?'#f3f4f6':'#eff6ff', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 14px', color }}>{icono}</div>
        <div style={{ fontWeight:700, fontSize:15, color:'#111827', marginBottom:6 }}>{titulo}</div>
        <div style={{ fontSize:13, color:'#6b7280', lineHeight:1.4 }}>{desc}</div>
    </div>
);

const SectionLabel = ({ icon, label, noMargin }) => (
    <div style={{ display:'flex', alignItems:'center', gap:8, margin: noMargin?0:'16px 0 12px', paddingBottom:8, borderBottom:'1px solid #f3f4f6' }}>
        <span style={{ fontSize:15 }}>{icon}</span>
        <span style={{ fontSize:11, fontWeight:700, color:'#374151', textTransform:'uppercase', letterSpacing:'0.07em' }}>{label}</span>
    </div>
);

const Field = ({ label, name, value, onChange, type='text', error }) => (
    <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
        <label className="u-field-label">{label}</label>
        <input type={type} name={name} value={value} onChange={onChange}
            className="u-input" style={{ borderColor: error?'#f87171':'#e5e7eb' }} />
        {error && <span style={{ fontSize:11, color:'#dc2626' }}>{error}</span>}
    </div>
);

// ── Paginación ────────────────────────────────────────────────────────────────
const Paginacion = ({ pagina, total, onChange, desde, hasta, totalItems }) => {
    if (total <= 1) return null;
    const pages   = Array.from({ length:total }, (_,i) => i+1);
    const visible = pages.filter(p => p===1 || p===total || Math.abs(p-pagina)<=1);
    return (
        <div className="ca-pagination">
            <span className="ca-pag-info">Mostrando <strong>{desde}–{hasta}</strong> de <strong>{totalItems}</strong> usuarios</span>
            <div className="ca-pag-btns">
                <PagBtn onClick={() => onChange(pagina-1)} disabled={pagina===1}><IconChevL /></PagBtn>
                {visible.reduce((acc,p,i,arr) => {
                    if (i>0 && arr[i-1]!==p-1) acc.push(<span key={`d${p}`} style={{ padding:'0 4px', color:'#9ca3af' }}>…</span>);
                    acc.push(<PagBtn key={p} active={p===pagina} onClick={() => onChange(p)}>{p}</PagBtn>);
                    return acc;
                }, [])}
                <PagBtn onClick={() => onChange(pagina+1)} disabled={pagina===total}><IconChevR /></PagBtn>
            </div>
        </div>
    );
};

const PagBtn = ({ children, active, disabled, onClick }) => (
    <button onClick={onClick} disabled={disabled} className={`ca-pag-btn${active?' active':''}`}>
        {children}
    </button>
);